<template>
  <div
    class="modal-card"
    v-if="link">
    <div class="row-width-actions-bar">
      <div class="columns is-gapless is-vcentered is-border-bottom">
        <div class="column is-padding-left">
          <div class="has-text-dark is-size-6 is-uppercase">
            <span class="has-text-weight-medium">Aperçu document</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square"
            @click="close">
            <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
          </a>
        </div>
      </div>
    </div>
    <section class="modal-card-body is-paddingless">
      <div class="columns is-gapless is-column is-minH100">
        <div class="column">
          <iframe
            :src="link"
            width="100%"
            height="100%"
            style="border: none;min-height: calc(-50px + 100vh);">
            <p>Your browser does not support PDFs.
            <a :href="link">Download the PDF</a>.</p>
          </iframe>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'YouSignPreview',
  props: {
    active: {
      type: Boolean,
      required: true
    },
    params: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState(['device']),
    link () {
      return this.params.link
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>
